export default __webpack_public_path__ + "static/media/762.47b09dec.gif";